import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../../../../../../configs/WebServiceUrl";

export const sendMobileOtpThunk = createAsyncThunk(
  "auth/sendMobileOtp",
  async (payload, thunkAPI) => {
    try {
      const res = await axios.post(
        `${BASE_URL}/api/adminauth/sendOTPMobile`,
        payload
      );

      if (!res.data.success) {
        return thunkAPI.rejectWithValue(res.data.message);
      }

      return { success: true, message: res.data.message };
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const verifyMobileOtpThunk = createAsyncThunk(
  "auth/verifyMobileOtp",
  async (payload, thunkAPI) => {
    try {
      const res = await axios.post(
        `${BASE_URL}/api/adminauth/verifyMobileOtp`,
        payload
      );

      if (!res.data.success) {
        return thunkAPI.rejectWithValue(res.data.message || "Invalid OTP");
      }

      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const googleRegisterThunk = createAsyncThunk(
  "auth/googleRegister",
  async ({ token, register_type }, { rejectWithValue }) => {
    try {
      const res = await fetch(`${BASE_URL}/api/adminauth/google-registration`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, register_type }),
      });

      const data = await res.json();

      if (!res.ok) return rejectWithValue(data);

      return data;
    } catch (err) {
      return rejectWithValue({ error: "Network Error" });
    }
  }
);

const registerSlice = createSlice({
  name: "register",
  initialState: {
    loading: false,
    otpSent: false,
    otpVerified: false,
    error: null,
    isRegistered: false,
    googleEmail: "",
    mobile: "",
    adminName: "",
  },

  reducers: {
    resetAuthState: (state) => {
      state.loading = false;
      state.otpSent = false;
      state.otpVerified = false;
      state.error = null;
    },
    setIsRegistered(state, action) {
      state.isRegistered = action.payload;
    },
    setAutoFill(state, action) {
      state.adminName = action.payload.name;
      state.mobile = action.payload.mobile;
      state.googleEmail = action.payload.email;
    },
    clearGoogleAndMobile(state) {
      state.googleEmail = "";
      state.mobile = "";
    },
  },

  extraReducers: (builder) => {
    // SEND OTP
    builder
      .addCase(sendMobileOtpThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(sendMobileOtpThunk.fulfilled, (state) => {
        state.loading = false;
        state.otpSent = true;
      })
      .addCase(sendMobileOtpThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.otpSent = false;
      });

    // VERIFY OTP
    builder
      .addCase(verifyMobileOtpThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(verifyMobileOtpThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.otpVerified = true;
        state.mobile = action.payload?.user?.mobile || null;
        state.adminName = action.payload?.user?.name || null;
      })
      .addCase(verifyMobileOtpThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.otpVerified = false;
      });
    builder
      .addCase(googleRegisterThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(googleRegisterThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.googleEmail = action.payload.user.email;
        state.adminName = action.payload.user.name;
      })
      .addCase(googleRegisterThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {
  resetAuthState,
  setIsRegistered,
  clearGoogleAndMobile,
  setAutoFill,
} = registerSlice.actions;
export default registerSlice.reducer;
